import './label.scss'

export const Label = ({ title }: { title: string }) => {
  return <span className="Label">{title}</span>
}
